import gql from "graphql-tag";

export const FILTER_PROJECTS = gql`
  query ProjectsFilter(
    $StoreNumber: String
    $SequenceNumber: String
    $City: String
    $State: String
    $Active: Boolean
    $Locked: Boolean
    $Archived: Boolean
    $ConditionallyClosed: Boolean
    $DiscretionaryApproval: Boolean
  ) {
    projectsFilter(
      filterdropdown: {
        StoreNumber: $StoreNumber
        SequenceNumber: $SequenceNumber
        City: $City
        State: $State
        Active: $Active
        Locked: $Locked
        Archived: $Archived
        ConditionallyClosed: $ConditionallyClosed
        DiscretionaryApproval: $DiscretionaryApproval
      }
    ) {
      id
      projectName
      storeNumber
      projectedClosingDate
      closingStatus
      projectSequenceNumber
      sellers
      parcels
      address
      storeType
      projectType
      businessUnitType
      storeSequenceNumber
      attorney
      auditor
      paralegal
      regionalVP
      realEstateManager
      accountant
      designManager
      outsideCounsel
      cecFirm
      lastModified
      darkStoreNumber
      createdBy
      createdDate
      documents {
        id
        name
        categoryId
        file
        projectId
        deleted
        status
        executed
        executedDate
        type
        subType
        originatingDepartment
        url
        version
        lastModified
        modifiedBy
      }
    }
  }
`;

export const FETCH_PROJECTS = gql`
  query Projects(
    $field: SortFieldsEnum!
    $direction: SortDirectionEnum!
    $page: Int!
    $limit: Int!
    $StoreNumber: String
    $SequenceNumber: String
    $City: String
    $State: String
    $ProjectName: String
    $Active: Boolean
    $Locked: Boolean
    $Dropped: Boolean
    $Closed: Boolean
    $ConditionallyClosed: Boolean
    $DiscretionaryApproval: Boolean
    $userId: String
  ) {
    fetchProjects(
      sort: { field: $field, direction: $direction }
      limit: $limit
      page: $page
      filterdropdown: {
        StoreNumber: $StoreNumber
        SequenceNumber: $SequenceNumber
        City: $City
        State: $State
        ProjectName: $ProjectName
        Active: $Active
        Locked: $Locked
        Dropped: $Dropped
        Closed: $Closed
        ConditionallyClosed: $ConditionallyClosed
        DiscretionaryApproval: $DiscretionaryApproval
      }
      externalUserId: $userId
    ) {
      ProjectsCount
      DiscretionaryApprovalYesCount
      Projects {
        store_nbr
        project_seq_nbr
        closing_name
        parcel_count
        last_change_ts
        closing_start_ts
        closing_id
        remFirstName
        remLastName
        status_code_desc
        city_name
        state_prov_code
        disc_approval_ind
        closing_id
      }
    }
  }
`;

export const FETCH_PROJECT = gql`
  query Project($projectID: Int!) {
    project(id: $projectID) {
      id
      projectName
      storeNumber
      projectedClosingDate
      closingStatus
      projectSequenceNumber
      sellers
      parcels
      address
      storeType
      projectType
      businessUnitType
      storeSequenceNumber
      attorney
      auditor
      paralegal
      regionalVP
      realEstateManager
      accountant
      designManager
      outsideCounsel
      cecFirm
      lastModified
      darkStoreNumber
      createdBy
      createdDate
      documents {
        id
        name
        categoryId
        file
        projectId
        deleted
        status
        executed
        executedDate
        type
        subType
        originatingDepartment
        url
        version
        lastModified
        modifiedBy
      }
    }
  }
`;

export const UPDATE_PROJECT = gql`
  mutation UpdateProject(
    $closing_id: Int!
    $property_id: Int!
    $project_seq_nbr: Int
    $parcel_count: Int
    $closing_start_ts: Date
    $status_code: Int
    $last_change_userid: String
    $seller_count: Int
    $status_code_desc: String
    $store_nbr: Int
    $disc_approval_ind: Boolean
    $closing_name: String
    $jde_company_nbr: String
    $addr_line1: String
    $city_name: String
    $state_prov_code: String
    $store_type_code: String
    $project_type_desc: String
    $bu_type_code: String
    $store_seq_nbr: String
    $dark_store_nbr: String
    $addr_book_nbr: String
    $company_nbr: String
    $division_nbr: String
    $project_entity_rec_id: String
    $desk_audit_closing_actual_date: String
  ) {
    updateProject(
      projectData: {
        closing_id: $closing_id
        property_id: $property_id
        project_seq_nbr: $project_seq_nbr
        parcel_count: $parcel_count
        closing_start_ts: $closing_start_ts
        status_code: $status_code
        last_change_userid: $last_change_userid
        seller_count: $seller_count
        status_code_desc: $status_code_desc
        store_nbr: $store_nbr
        disc_approval_ind: $disc_approval_ind
        closing_name: $closing_name
        jde_company_nbr: $jde_company_nbr
        addr_line1: $addr_line1
        city_name: $city_name
        state_prov_code: $state_prov_code
        store_type_code: $store_type_code
        project_type_desc: $project_type_desc
        bu_type_code: $bu_type_code
        store_seq_nbr: $store_seq_nbr
        dark_store_nbr: $dark_store_nbr
        addr_book_nbr: $addr_book_nbr
        company_nbr: $company_nbr
        division_nbr: $division_nbr
        project_entity_rec_id: $project_entity_rec_id
        desk_audit_closing_actual_date: $desk_audit_closing_actual_date
      }
    ) {
      Success
      Message
      ErrorCode
      closingId
      storeMigration {
        oldStoreNumber
        newStoreNumber
        totalDocuments
        successCount
        failedCount
        failedDocuments {
          docId
          fileName
          message
        }
        storeNumberChanged
        storeDetailsChanged
        dwmError
        DuplicateFiles {
          documentId
          updatedName
        }
        duplicateCount
      }
      linkedDocuments {
        fileName
        categoryName
      }
      blockedDocuments {
        documentName
        projectsLinked {
          projectName
          categoryName
        }
      }
    }
  }
`;

export const UNLOCK_PROJECT = gql`
  mutation UnlockProject(
    $closing_id: Int!
  ) {
    unlockProject(
      projectData: { 
        closing_id: $closing_id
      }
    ) {
      Success
      Message
    }
  }
`;

export const LOCK_PROJECT = gql`
  mutation LockProject(
    $closing_id: Int!
  ) {
    lockProject(
      projectData: { 
        closing_id: $closing_id
      }
    ) {
      Success
      Message
    }
  }
`;

export const CLOSE_PROJECT = gql`
  mutation CloseProject(
    $closing_id: Int!
    $desk_audit_closing_actual_date: String
  ) {
    closeProject(
      projectData: { 
        closing_id: $closing_id
        desk_audit_closing_actual_date: $desk_audit_closing_actual_date
      }
    ) {
      Success
      Message
    }
  }
`;

export const CONDITIONALLY_CLOSE_PROJECT = gql`
  mutation ConditionallyCloseProject(
    $closing_id: Int!
  ) {
    conditionallyCloseProject(
      projectData: { 
        closing_id: $closing_id
      }
    ) {
      Success
      Message
    }
  }
`;

export const DROP_PROJECT = gql`
  mutation DropProject(
    $closing_id: Int!
  ) {
    dropProject(
      projectData: { 
        closing_id: $closing_id
      }
    ) {
      Success
      Message
    }
  }
`;

export const CREATE_PROJECT = gql`
  mutation CreateProject(
    $address_line_1: String
    $city_name: String
    $state_prov_code: String
    $store_nbr: Int
    $project_seq_nbr: Int
    $parcel_count: Int
    $jde_company_nbr: String
    $status_code: Int
    $seller_count: Int
    $closing_name: String
    $outsideCouncil: [String]
    $cecFirms: String
    $auditor: String
    $paraLegal: String
    $regionalVicePresident: String
    $accountant: String
    $attorney: String
    $realEstateManager: String
    $designManager: String
    $country_code: String
    $project_type_code: Int
    $closing_type_code: Int
    $last_change_userid: String
    $rstrct_access_ind: String
    $location_desc: String
    $postal_code: String
    $prop_usage_code: Int
    $region_nbr: Int
    $closing_start_ts: String
    $closing_desc: String
    $project_entity_rec_id: String
    $desk_audit_closing_actual_date: String
  ) {
    createProject(
      project: {
        addr_line1: $address_line_1
        city_name: $city_name
        state_prov_code: $state_prov_code
        store_nbr: $store_nbr
        project_seq_nbr: $project_seq_nbr
        parcel_count: $parcel_count
        jde_company_nbr: $jde_company_nbr
        status_code: $status_code
        seller_count: $seller_count
        closing_name: $closing_name
        outsideCouncil: $outsideCouncil
        cecFirms: $cecFirms
        auditor: $auditor
        plAdmin: $paraLegal
        regionalVicePresident: $regionalVicePresident
        accountant: $accountant
        generalCouncil: $attorney
        portfolioManager: $realEstateManager
        districtManager: $designManager
        country_code: $country_code
        project_type_code: $project_type_code
        closing_type_code: $closing_type_code
        last_change_userid: $last_change_userid
        rstrct_access_ind: $rstrct_access_ind
        location_desc: $location_desc
        postal_code: $postal_code
        prop_usage_code: $prop_usage_code
        region_nbr: $region_nbr
        closing_start_ts: $closing_start_ts
        closing_desc: $closing_desc
        project_entity_rec_id: $project_entity_rec_id
        desk_audit_closing_actual_date: $desk_audit_closing_actual_date
      }
    ) {
      Success
      ClosingId
      Message
    }
  }
`;

export const CREATE_PROJECT_OLD = gql`
  mutation CreateProject(
    $id: Int
    $projectName: String
    $storeNumber: Int
    $projectedClosingDate: String
    $closingStatus: String
    $projectSequenceNumber: Int
    $sellers: Int
    $parcels: Int
    $address: String
    $storeType: String
    $projectType: String
    $businessUnitType: String
    $storeSequenceNumber: Int
    $attorney: String
    $auditor: String
    $paralegal: String
    $regionalVP: String
    $realEstateManager: String
    $accountant: String
    $designManager: String
    $outsideCounsel: String
    $cecFirm: String
    $lastModified: String
    $modifiedBy: String
    $darkStoreNumber: Int
    $createdBy: String
    $createdDate: String
  ) {
    createProject(
      project: {
        id: $id
        projectName: $projectName
        storeNumber: $storeNumber
        projectedClosingDate: $projectedClosingDate
        closingStatus: $closingStatus
        projectSequenceNumber: $projectSequenceNumber
        sellers: $sellers
        parcels: $parcels
        address: $address
        storeType: $storeType
        projectType: $projectType
        businessUnitType: $businessUnitType
        storeSequenceNumber: $storeSequenceNumber
        attorney: $attorney
        auditor: $auditor
        paralegal: $paralegal
        regionalVP: $regionalVP
        realEstateManager: $realEstateManager
        accountant: $accountant
        designManager: $designManager
        outsideCounsel: $outsideCounsel
        cecFirm: $cecFirm
        lastModified: $lastModified
        modifiedBy: $modifiedBy
        darkStoreNumber: $darkStoreNumber
        createdBy: $createdBy
        createdDate: $createdDate
      }
    ) {
      id
      projectName
      storeNumber
      projectedClosingDate
      closingStatus
      projectSequenceNumber
      sellers
      parcels
      storeSequenceNumber
      attorney
      auditor
      paralegal
      regionalVP
      realEstateManager
      accountant
      designManager
      outsideCounsel
      cecFirm
      createdDate
    }
  }
`;

export const FETCH_PROJECT_DETAILS = gql`
  query Project($closing_id: Int!) {
    fetchProjectDetails(closing_id: $closing_id) {
      Success
      Message
      projectDetails {
        property_id
        location_desc
        addr_line1
        city_name
        state_prov_code
        postal_code
        store_nbr
        country_code
        last_change_ts
        project_type_code
        prop_usage_code
        project_seq_nbr
        region_nbr
        parcel_count
        jde_company_nbr
        closing_name
        closing_desc
        last_change_ts_pct
        closing_id
        closing_ts
        closing_start_ts
        closing_end_ts
        closing_type_code
        status_code
        last_change_ts
        last_change_userid
        seller_count
        rstrct_access_ind
        status_code_desc
        project_type_desc
        closing_type_desc
        closing_type_name
        disc_approval_ind
        project_entity_rec_id
        desk_audit_closing_actual_date
      }
      storeDetails {
        r_object_id
        jde_bu_nbr
        bu_type_code
        div_nbr
        store_nbr
        dark_store_nbr
        company
        store_seq_nbr
        project_source
        store_type_code
        project_type_code
        proj_seq_nbr
        address_book_nbr
        address_line_1
        city_name
        state_prov_code
      }
    }
  }
`;

export const PROP_CLOSING_CATGS = gql`
  query propClosingCatgs($closing_id: Int!) {
    propClosingCatgs(closing_id: $closing_id) {
      closing_id
      doc_category_id
      closing_type_code
      category_name
      doc_count
    }
  }
`;

export const FETCH_PROJECT_STATUS = gql`
  query {
    fetchAllClosingStatus {
      status_code
      status_code_desc
    }
  }
`;

export const FETCH_STORE_DETAILS = gql`
  query fetchStoreDetailsFromJDE($storeNumber: Int!) {
    fetchStoreDetailsFromJDE(storeNumber: $storeNumber) {
      Success
      Stores {
        r_object_id
        jde_bu_nbr
        bu_type_code
        div_nbr
        store_nbr
        dark_store_nbr
        company
        store_seq_nbr
        project_source
        store_type_code
        project_type_code
        proj_seq_nbr
        address_book_nbr
        address_line_1
        city_name
        state_prov_code
      }
    }
  }
`;

export const FETCH_STORE_DETAILS_BY_COMPANY = gql`
  query fetchStoreDetailsByCompanyFromJDE($companyNumber: String!) {
    fetchStoreDetailsByCompanyFromJDE(companyNumber: $companyNumber) {
      Success
      Stores {
        r_object_id
        jde_bu_nbr
        bu_type_code
        div_nbr
        store_nbr
        dark_store_nbr
        company
        store_seq_nbr
        project_source
        store_type_code
        project_type_code
        proj_seq_nbr
        address_book_nbr
        address_line_1
        city_name
        state_prov_code
      }
    }
  }
`;

export const GET_LATEST_PROJECT_STATUS = gql`
  query GetLatestProjectStatus($closing_id: Int!) {
    latestProjectStatus(closing_id: $closing_id) {
      status_code_desc
      modified_by_user_name
      modified_timestamp
    }
  }
`;

export const GET_PROJECT_STATUS_HISTORY = gql`
  query GetProjectStatusHistory(
    $closing_id: Int!
    $limit: Int
    $page: Int
    $field: StatusSortFieldsEnum
    $direction: SortDirectionEnum
  ) {
    projectStatusHistory(
      closing_id: $closing_id
      limit: $limit
      page: $page
      sort: { field: $field, direction: $direction }
    ) {
      totalCount
      records {
        id
        status_code_desc
        modified_by_user_name
        modified_timestamp
      }
    }
  }
`;

/* Bulk Reports APIs */
  export const FETCH_BULK_PROJECT_DETAILS = gql`
    query FetchBulkProjectDetails(
    $field: SortFieldsEnum!
    $direction: SortDirectionEnum!
    $StoreNumber: String
    $SequenceNumber: String
    $City: String
    $State: String
    $ProjectName: String
    $Active: Boolean
    $Locked: Boolean
    $Dropped: Boolean
    $Closed: Boolean
    $ConditionallyClosed: Boolean
    $DiscretionaryApproval: Boolean
    $userId: String
    $includeProjectDetails: Boolean!
    $includeStoreDetails: Boolean!
    $includeUserDetails: Boolean!
    $downloadExcel: Boolean
  ) {
    fetchBulkProjectDetails(
      sort: { field: $field, direction: $direction }
      filterdropdown: {
        StoreNumber: $StoreNumber
        SequenceNumber: $SequenceNumber
        City: $City
        State: $State
        ProjectName: $ProjectName
        Active: $Active
        Locked: $Locked
        Dropped: $Dropped
        Closed: $Closed
        ConditionallyClosed: $ConditionallyClosed
        DiscretionaryApproval: $DiscretionaryApproval
      }
      externalUserId: $userId
      includeProjectDetails: $includeProjectDetails
      includeStoreDetails: $includeStoreDetails
      includeUserDetails: $includeUserDetails
      downloadExcel: $downloadExcel
    ) {
      Success
      Message
      ExcelData
      Projects {
        closing_id
        closing_name
        project_seq_nbr
        status_code_desc
        store_nbr
        city_name
        state_prov_code
        closing_start_ts
        last_change_ts
        parcel_count
        disc_approval_ind
        projectDetails {
          property_id
          location_desc
          addr_line1
          postal_code
          country_code
          project_type_code
          prop_usage_code
          region_nbr
          jde_company_nbr
          closing_desc
          closing_ts
          closing_end_ts
          closing_type_code
          status_code
          last_change_userid
          seller_count
          rstrct_access_ind
          project_type_desc
          closing_type_desc
          closing_type_name
        }
        storeDetails {
          r_object_id
          jde_bu_nbr
          bu_type_code
          div_nbr
          dark_store_nbr
          company
          store_seq_nbr
          store_type_code
          project_type_code
          proj_seq_nbr
          address_book_nbr
          address_line_1
        }
        users {
          closing_id
          role_id
          sys_userid
          last_change_ts
          user_approved_ind
          role_name
          role_desc
          external_user_ind
          extrn_first_name
          extrn_last_name
        }
      }
    }
  }
`;

export const FETCH_RECIPIENTS_BY_PROJECT = gql`
  query fetchRecipientsByProject($closing_id: Int!) {
    fetchRecipientsByProject(closingId: $closing_id) {
      sys_userid
      fullname
      ext_email_addr_id
      role_desc
    }
  }
`;

export const EXPORT_BULK_COMMENTS = gql`
  query ExportBulkProjectComments(
    $field: SortFieldsEnum!
    $direction: SortDirectionEnum!
    $StoreNumber: String
    $SequenceNumber: String
    $City: String
    $State: String
    $ProjectName: String
    $Active: Boolean
    $Locked: Boolean
    $Dropped: Boolean
    $Closed: Boolean
    $ConditionallyClosed: Boolean
    $DiscretionaryApproval: Boolean
    $userId: String
  ) {
    exportBulkProjectComments(
      sort: { field: $field, direction: $direction }
      filterdropdown: {
        StoreNumber: $StoreNumber
        SequenceNumber: $SequenceNumber
        City: $City
        State: $State
        ProjectName: $ProjectName
        Active: $Active
        Locked: $Locked
        Dropped: $Dropped
        Closed: $Closed
        ConditionallyClosed: $ConditionallyClosed
        DiscretionaryApproval: $DiscretionaryApproval
      }
      externalUserId: $userId
    )
  }
`;
export const FETCH_PROJECT_EMAIL_NOTIFICATION_HISTORY = gql`
  query fetchProjectEmailNotificationHistory($closing_id: Int!) {
    fetchProjectEmailNotificationHistory(closingId: $closing_id) {
      id
      subject
      created_at
      sender
      recipients
      message
    }
  }
`;

export const SEND_EMAIL_NOTIFICATION = gql`
  mutation sendEmailNotification($emailInput: EmailNotificationInputType!) {
    sendEmailNotification(emailInput: $emailInput) {
      Success
      Message
      MessageId
      Error
    }
  }
`;
